import { emptyFragment } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { chatMetadataStore } from '../../ChatStores/ChatMetadataStore';

function SelectedLicense() {
  return (
    <div className="overflow-visible relative pb-1">
      {chatMetadataStore.selectedProductLicense
        .map((license) => (
          <span
            id="chat-selected-license"
            key={license.id}
            className={clsx(
              'ml-4 px-2.5 py-1.5 rounded-full bg-gray-200 text-gray-700 text-xs self-start',
            )}
          >
            {license.name}
          </span>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(SelectedLicense);
